import React, {Component} from 'react';
import {connect} from 'react-redux';
import {DatePicker} from 'antd';
import {SelectHelper} from "../DataEntry/utils/helper";

/**
 * Supported options:
 * -
 **/
class BukkuDatePicker extends Component {
    onOpenChange = isOpen => {
        if (isOpen) {
            setTimeout(() => {
                const startInput = document.querySelector('.ant-calendar-input');
                if (startInput)
                    startInput.select();
            }, 100);
        }
    };

    render() {
        const {
            dateFormatList,
            pickerRef,
            readOnly,
            allowClear,
            popupContainerId,
            ...restProps
        } = this.props;

        return <DatePicker
            style={{ width: '100%' }}
            allowClear={allowClear || false}
            onOpenChange={this.onOpenChange}
            getPopupContainer={SelectHelper.getPopupContainer(popupContainerId)}
            format={dateFormatList}
            placeholder="DD/MM/YYYY"
            ref={pickerRef}
            {...restProps}
        />;
    }
}
export default connect(state => ({
    dateFormatList: state.App.dateFormatList,
}), {
    //
})(BukkuDatePicker);
